import PropTypes from 'prop-types';
import React from 'react';
import { excludedItem } from '../modules/excludedItems';
import { track } from '../modules/tracking';

import { MenuInner } from '.';
import { OPEN, PRODUCT_DESCRIPTION_FOR } from '../modules/constants';
import { noAllergens, noDietaryConstraints } from '../modules/filtering';

const ACTIVE_CLASS_NAME = 'active';

/**
 * Menu item card view.
 *
 * @function
 * @param       {object} props props to display the menu item
 * @constructor
 */
function MenuItem(props) {
    const {
        allergenFilter,
        allergens,
        bastes,
        description,
        dietFilter,
        diets,
        displayName,
        flippedProps,
        fulfilmentTypes,
        modifiers,
        nutritionalInfo,
        flags,
        hideCalories,
        idx,
        image,
        nandinos,
        order,
        possibleSides,
        priceList,
        depositFee,
        short,
        pdpInfo,
        slug,
        setPdpInfo,
        sectionName,
        servingInfo
    } = props;

    if (
        !noAllergens({ allergens, allergenFilter }) ||
        !noDietaryConstraints({ diets, dietFilter }) ||
        excludedItem(slug) ||
        fulfilmentTypes.length === 0
    ) {
        return null;
    }

    //console.log('dis', displayName, slug);
    let className;

    if (pdpInfo && pdpInfo.displayName === displayName) {
        className = ACTIVE_CLASS_NAME;
    }

    if (image && image.featured) {
        className = className ? ' featured' : 'featured';
    }

    /**
     * Push the info in this menu item into the global pdpInfo state object.
     *
     * @function
     * @param    {Event} e  event we wish to cancel
     */
    function openPDPInfoBox(e) {
        e.preventDefault();
        e.stopPropagation();

        if (window.localStorage) {
            window.localStorage.clear();
            window.sessionStorage.clear();
        }

        if (setPdpInfo) {
            const infoProps = {
                allergens,
                bastes,
                description,
                diets,
                displayName,
                flags,
                fulfilmentTypes,
                hideCalories,
                idx,
                image,
                modifiers,
                nandinos,
                nutritionalInfo,
                order,
                possibleSides,
                priceList,
                depositFee,
                sectionName,
                servingInfo,
                short,
                slug
            };
            setPdpInfo(infoProps);
        }
        track(`MenuItem: Click: ${OPEN} ${displayName}`)();
    }

    return (
        <button
            onClick={openPDPInfoBox}
            className={className}
            {...flippedProps}
            title={`${OPEN} ${PRODUCT_DESCRIPTION_FOR} ${props.displayName}`}
        >
            <MenuInner {...props} short={true} />
        </button>
    );
}

MenuItem.propTypes = {
    allergenFilter: PropTypes.object,
    allergens: PropTypes.arrayOf(PropTypes.object),
    bastes: PropTypes.arrayOf(PropTypes.object),
    description: PropTypes.string,
    dietFilter: PropTypes.arrayOf(PropTypes.string),
    diets: PropTypes.arrayOf(PropTypes.string),
    displayName: PropTypes.string,
    flags: PropTypes.array,
    flippedProps: PropTypes.object,
    fulfilmentTypes: PropTypes.arrayOf(PropTypes.string),
    hideCalories: PropTypes.bool,
    idx: PropTypes.number,
    image: PropTypes.object,
    modifiers: PropTypes.arrayOf(PropTypes.object),
    nandinos: PropTypes.bool,
    nutritionalInfo: PropTypes.object,
    order: PropTypes.number,
    pdpInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    possibleSides: PropTypes.arrayOf(PropTypes.object),
    priceList: PropTypes.array,
    depositFee: PropTypes.shape({
        currencyCode: PropTypes.string,
        value: PropTypes.number
    }),
    sectionName: PropTypes.string,
    servingInfo: PropTypes.string,
    setPdpInfo: PropTypes.func,
    short: PropTypes.bool,
    slug: PropTypes.string
};

export { MenuItem };
